import { render, staticRenderFns } from "./AssignmentDetailsTab.vue?vue&type=template&id=6b3bdd30&scoped=true&"
import script from "./AssignmentDetailsTab.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3bdd30",
  null
  
)

export default component.exports